import { useState } from "react";

const API_URL = process.env.REACT_APP_API_URL;

export default function UseEsqueciSenha() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(null);

  const validateEmail = (email) => {
    const value = email.trim();

    if (!value) {
      setError("");
      return;
    }

    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!regex.test(value)) {
      setError("Email inválido");
      return;
    }

    return "";
  };
  const enviarEmail = async (email) => {
    try {
      setLoading(true);
      setError("");
      setSuccess("");

      const response = await fetch(`${API_URL}/api/auth/esqueci-senha/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      });

      const data = await response.json().catch(() => ({}));

      if (!response.ok) {
        throw new Error(data?.detail || "Erro ao enviar email.");
      }

      setSuccess(data.detail || "Email enviado com sucesso!");
      setEmail("");
      return true;
    } catch (err) {
      setError(err.message || "Erro inesperado.");
      return false;
    } finally {
      setLoading(false);
    }
  };

  return {
    email,
    setEmail,
    enviarEmail,
    validateEmail,
    loading,
    error,
    setError,
    success,
    setSuccess,
  };
}
